import {gql} from '@apollo/client'

export const GetListingProductsDocument = gql`
    query GetListingProducts($currentPage: Int!, $sort: ProductAttributeSortInput = {}, $filter: ProductAttributeFilterInput = {}, $pageSize: Int = 12) {
        products(
            pageSize: $pageSize
            currentPage: $currentPage
            sort: $sort
            filter: $filter
        ) {
            page_info {
                current_page
                page_size
                total_pages
            }
            sort_fields {
                default
                options {
                    label
                    value
                }
            }
            total_count
            items {
                omnibus_price
                id
                name
                price {
                    regularPrice {
                        amount {
                            currency
                            value
                        }
                    }
                    minimalPrice {
                        amount {
                            currency
                            value
                        }
                    }
                }
                price_range {
                    minimum_price {
                        regular_price {
                            currency
                            value
                        }
                        final_price {
                            value
                            currency
                        }
                    }
                }
#                related_products {
#                    color
#                }
                ... on BundleProduct {
                    items {
                        title
                        options {
                            uid
                            id
                            quantity
                            product {
                                omnibus_price
                                id
                                sku
                                url_key
                                name
#                                rozmiar_swatch
#                                kolor3_swatch
#                                material_swatch
                                salable_qty
                            }
                        }
                    }
                }
#                ... on CustomizableProductInterface {
#                    options {
#                        title
#                        required
#                        sort_order
#                        uid
#                        ... on CustomizableDropDownOption {
#                            dropDown: value {
#                                sku
#                                price
#                                uid
#                            }
#                        }
#                    }
#                }
                sku
                url_key
                salable_qty
                image {
                    label
                    url
                }
                hover
#                material_swatch
#                rozmiar_swatch
#                upsell_products {
#                    material_swatch
#                    rozmiar_swatch
#                }
#                categories {
#                    name
#                }
                main_category {
                    name
                    url_key
                }
                media_gallery {
                    url
                    label
                    disabled
                    position
                    types
                }
#                vimeo_videos
            }
        }
    }
`